import type { InvitationDetails } from '../types';

/**
 * Why an invitation link cannot be used, for the registration and decision
 * pages. A link a reminder replaced points to the newest mail (ClickUp
 * 869fmx898) instead of calling it invalid.
 */
export const invitationErrorKey = (state?: InvitationDetails['linkState'] | string) => {
  if (state === 'expired') return 'auth.register.invitationExpired';
  if (state === 'used') return 'auth.register.invitationUsed';
  if (state === 'revoked') return 'auth.register.invitationRevoked';
  if (state === 'superseded') return 'auth.register.invitationSuperseded';
  return 'auth.register.invitationInvalid';
};
